import React from 'react';
import { Activity } from 'lucide-react';
import SectionHeading from './SectionHeading';
import { BarChart, LineChart, SplitBars } from './charts';
import { dashboardDemo } from '../lib/liveData';

export default function DashboardDemo() {
  return (
    <section className="relative max-w-7xl mx-auto px-5 md:px-8 section-pad">
      <SectionHeading
        eyebrow="Client Dashboard"
        title={<span>Your growth, <span className="text-gradient-cyan">in real time.</span></span>}
        subtitle="A live, transparent view of spend, installs, revenue and ROAS across every channel."
      />

      <div className="reveal glass-strong rounded-3xl p-6 md:p-8">
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center gap-2">
            <span className="w-9 h-9 rounded-lg bg-gradient-to-br from-[#2563eb] to-[#1d4ed8] grid place-items-center"><Activity size={18} className="text-white" /></span>
            <div>
              <div className="text-sm font-semibold text-slate-900 leading-none">Campaign Overview</div>
              <div className="text-[10px] text-slate-500 mt-1">Sample data · refreshes daily</div>
            </div>
          </div>
          <span className="rounded-full bg-slate-100 border border-slate-200 px-3 py-1 text-[11px] text-slate-500">Last 12 weeks</span>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 mb-6">
          {dashboardDemo.metrics.map((m) => (
            <div key={m.label} className="rounded-xl border border-slate-200 bg-slate-50 p-4">
              <div className="text-[11px] text-slate-500">{m.label}</div>
              <div className="font-display text-xl font-bold text-slate-900 mt-1">{m.value}</div>
            </div>
          ))}
        </div>

        <div className="grid lg:grid-cols-3 gap-4">
          <div className="rounded-2xl border border-slate-200 bg-slate-50 p-5">
            <div className="text-xs text-slate-500 mb-3">Spend by week</div>
            <BarChart data={dashboardDemo.spendBars} color="#2563eb" height={110} />
          </div>
          <div className="rounded-2xl border border-slate-200 bg-slate-50 p-5">
            <div className="text-xs text-slate-500 mb-3">Revenue trend</div>
            <LineChart data={dashboardDemo.revenueLine} color="#4f46e5" height={110} />
          </div>
          <div className="rounded-2xl border border-slate-200 bg-slate-50 p-5">
            <div className="text-xs text-slate-500 mb-3">Channel split</div>
            <SplitBars items={dashboardDemo.channelSplit} />
          </div>
        </div>
      </div>
    </section>
  );
}
